<template>
    <div class="game-header">
        <div class="game-header__box">
            <span>
                <span v-if="date.years">{{ date.years }} {{ date.years | numerate('год:::года:::лет') }} </span>
                <span v-if="date.months">{{ date.months }} {{ date.months | numerate('месяц:::месяца:::месяцев') }} </span>
                <span>{{ date.days }} {{ date.days | numerate('день:::дня:::дней') }}</span>
            </span>

            <span class="game-header__control" v-if="$route.name === 'game-runtime'">
                <block-control />
            </span>

            <span class="game-header__balance">
                {{ balance }} {{ balance | numerate('балл:::баллa:::баллов') }}
                <transition-group name="add">
                    <span class="game-header__change" v-for="item in changes" :key="item.id">+{{ item.value }}</span>
                </transition-group>
            </span>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'

    export default {
        components: {},
        data () {
            return {
                changes: []
            }
        },
        computed: {
            ...mapGetters(['date']),
            ...mapState('balance', ['balance'])
        },
        watch: {
            balance (newValue, oldValue) {
                if (newValue > oldValue) {
                    const id = Date.now()
                    this.changes.push({id, value: newValue - oldValue})
                    setTimeout(() => {
                        const index = this.changes.findIndex(item => item.id === id)
                        this.changes.splice(index, 1)
                    }, 20000)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .game-header {
        box-sizing border-box
        padding 0 6.1rem
        display flex
        color #93C9FF
        font-size 1.5rem
        line-height 1.8rem
        font-weight $font-bold
        position relative

        +layout-sm() {
            padding 0 2.7rem
        }
        +layout-xs() {
            padding 0 2rem
        }
        +layout-xxs() {
            font-size 1.3rem
        }
        &__balance {
            position relative
        }
        &__change {
            position absolute
            top 0
            left -0.9rem
            opacity 0
        }
        &__control {
            position absolute
            top 1.4rem
            right 40rem
            +layout-sm() {
                right 50%
                transform translate(50%, 0)
            }
            +layout-xs() {
                right 10rem
                transform translate(0, 0)
            }
            +layout-xxs() {
                right 7.8rem
            }
        }
        &__box {
            position relative
            padding-top 0.3rem
            width 100%
            display flex
            justify-content space-between
            align-items center
            height 5.6rem

            &::after {
                content ""
                display none
                +layout-sm() {
                    display block
                    background-color #2B0EAF
                    height 1px
                    width 100%
                    position absolute
                    bottom -1px
                    left 0
                }
            }

            +layout-xs() {
                height 5.8rem
            }
        }
    }
    .add-enter-active {
        animation add 1s 1 forwards
    }
    @keyframes add {
        0% {
            opacity 0
            transform translate(0, 0)
        }
        50% {
            opacity 1
        }
        100% {
            opacity 0
            transform translate(0, -1.6rem)
        }
    }
</style>
